export class ContractAddress {
  public id: number;
  public code: string; // Почтовый код
  public region: string; // Регион
  public district: string; // Район
  public locality: {
    type: string; // Тип населённого пункта
    name: string; // Название населённого пункта
  };
  public road: {
    type: string; // Тип улицы
    name: string; // Название улицы
  };
  public building: string; // Номер дома
  public housing: string; // Корпус
  public apartment: string; // Номер квартиры(офиса)

  constructor(item?) {
    this.update(item);
  }

  public update(el): void {
    if (!el) {
      return;
    }

    Object.assign(this, el);

    if (el.locality) {
      Object.assign(this.locality, el.locality);
    }

    if (el.road) {
      Object.assign(this.road, el.road);
    }
  }
}
